import { render } from "./NewEditClient.vue?vue&type=template&id=1ea3a89e&scoped=true"
import script from "./NewEditClient.vue?vue&type=script&lang=js"
export * from "./NewEditClient.vue?vue&type=script&lang=js"

import "./NewEditClient.vue?vue&type=style&index=0&id=1ea3a89e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea3a89e"]])

export default __exports__